<template>
  <div class="container">
    <div class="row">
      <div class="col">
          <div class="pt-3 pb-3">
            <router-view></router-view>
          </div>
      </div>
    </div>    
    <!-- KVKK MODAL -->
    <div v-if="kvkkModalVisible" class="modal fade show"  style="display: block" tabindex="-1" role="dialog" @click.self="kvkkModalVisible = false">
        <div  class="modal-dialog modal-xl modal-dialog-scrollable">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">KVKK Metni</h5>
                <a href="#void" class="close" data-dismiss="modal" aria-label="Kapat" @click="kvkkModalVisible = false">
                    <span aria-hidden="true">&times;</span>
                </a>
            </div>
            <div id="kvkkModal" class="modal-body">
              <PDFViewer2 :pdfUrl="getKVKKUrl()" :control-visible="false" :custom-width="customWidth"></PDFViewer2>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" @click="kvkkModalVisible = false" data-dismiss="modal">Kapat</button>
            </div>
            </div>
        </div>
    </div>
    <GlobalFooter style="z-index: 99;" @openKvkk="openKvkkModal"></GlobalFooter>
  </div>
</template>
<script>
import GlobalFooter from '../components/GlobalFooter.vue'
import axios from "axios";
import PDFViewer2 from '../components/PDFViewer2.vue';
export default {
  components: {
    GlobalFooter,
    PDFViewer2
  },
  data(){
    return{
      kvkkModalVisible: false,
      customWidth: null
    }
  },
  mounted(){
    console.log("OpenId Key:",this.$route.query);

    if (
      this.$route.query != undefined &&
      this.$route.query != "" &&
      this.$route.query.code != undefined &&
      this.$route.query.code != "" &&
      this.$route.query.state != undefined &&
      this.$route.query.state != ""
    ){
      var stateInfo = this.$route.query.state;
      var codeInfo = this.$route.query.code;
      this.postOpenId(stateInfo,codeInfo)
    }
  },
  methods: {
    openKvkkModal(){
      this.kvkkModalVisible = true
      this.kvkkModalWidth()
    },
    kvkkModalWidth(){
      this.$nextTick(() => {
        var x = document.getElementById("kvkkModal").parentNode.parentElement.clientWidth;
        this.customWidth = x
      });
    },
    getKVKKUrl(){
      var kvkkUrl = window.settings.kvkkUrl
      if(kvkkUrl)
          return kvkkUrl;
      if(!window.settings.isOnPrem)
          return "https://www.izometri.com.tr/Content/kvkk/izonay-kvkk.pdf"
      return false;
      
    },
    postOpenId(stateInfo,codeInfo) {
      axios
        .post("mfaMicrosoft", {
          SessionId: stateInfo,
          Code: codeInfo,
        })
        .then((x) => {
          console.log("login result:", x);
          if (x.data.Success) {
            this.$router.push("/job?t=" + x.data.Data.Key);
          } else {
            //params.onFailed(x);
          }
        })
        .catch((x) => {
          if (x.response?.data?.ModelState?.MFASessionTimeoutException) {
            alert(x.response.data.ModelState.MFASessionTimeoutException);
            location.reload();
          } else if (x.response?.data?.ModelState?.MFASessionBlockedException) {
            alert(x.response.data.ModelState.MFASessionBlockedException);
            location.reload();
          } else if (x.response?.data?.ModelState?.MFAInvalidSessionException) {
            alert(x.response.data.ModelState.MFAInvalidSessionException);
            location.reload();
          } else {
            window.processErrorResponse(x, this);
            //params.onFailed(x);
          }
          this.$router.push("/");
        });
    },
  }
}
</script>
<style scoped>

</style>
